<div [id]="containerId" [class]="containerClass" [class.mobile-ad-banner__slot--hidden]="isVisible"></div>
<div
    class="mobile-ad-banner"
    [class.mobile-ad-banner--visible]="isVisible"
    *ngIf="isVisible"
    role="button"
    tabindex="0"
    (click)="showUpgradeModal()"
    (keydown.enter)="showUpgradeModal()"
    (keydown.space)="onSpace($event)">
    <img
        class="mobile-ad-banner__image"
        src="/assets/images/ad_banner_placeholder_mobile.png"
        alt="Upgrade to remove ads" />
</div>
